module.exports = __webpack_public_path__ + "static/media/undercity.49236a24.mp3";